













































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbLoadingService } from '@/shared/loading/loading.service';
import BindItemDatasourceRequest from '@/domain/contract/request/bind-item-datasource-request.entity';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ContractService from '@/domain/contract/service/contract.service';
import ProductTemplate from '@/domain/product-template/entity/product-template.entity';
import ProductTemplateService from '@/domain/product-template/service/product-template.service';
import ModalOptions from '../../../../../shared/modal/modal-options.entity';
import ContractItem from '../../../../../domain/contract/entity/contract-item.entity';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class SelectInstanceModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true, default: '' })
  businessUnitId!: string;

  @Prop()
  item!: ContractItem;

  @Prop()
  productTemplate!: ProductTemplate;

  @Prop({ required: true, default: [] })
  datasources!: Datasource[];

  boundDatasource: BindItemDatasourceRequest = new BindItemDatasourceRequest('');

  @Watch('show')
  applyBoundedItems() {
    if (this.item && this.item.datasource) {
      this.boundDatasource = new BindItemDatasourceRequest(this.item.datasource.id)
    }
    if (this.productTemplate && this.productTemplate.datasourceId) {
      this.boundDatasource = new BindItemDatasourceRequest(this.productTemplate.datasourceId)
    }
  }

  get title(): string {
    return this.productTemplate ? 'Padrão de Configuração de dados' : 'Configuração de dados';
  }

  get options(): ModalOptions {
    return {
      title: this.title,
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: false,
    }
  }

  handleDataSourceChange() {
    if (this.productTemplate) {
      this.checkProductTemplate();
      this.bindProductTemplateDatasource();
      return;
    }
    if (this.item) {
      this.bindContractItemDatasource();
    }
  }

  bindContractItemDatasource() {
    ContractService.bindItemDatasource(
      this.businessUnitId, this.item.id, this.boundDatasource,
    ).then((response: any) => {
      VbSnackbarService.showSuccess('Banco de dados vinculado com sucesso');
      this.success();
    })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  checkProductTemplate() {
    if (!this.productTemplate.id) {
      ProductTemplateService.createProductTemplate(this.businessUnitId, this.productTemplate)
        .then((response: any) => {
          this.productTemplate.id = response.id;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  bindProductTemplateDatasource() {
    if (this.productTemplate.id) {
      ProductTemplateService.bindProductTemplateDatasource(
        this.businessUnitId, this.productTemplate.id, this.boundDatasource,
      ).then((response: any) => {
        VbSnackbarService.showSuccess('Banco de dados vinculado com sucesso');
        this.success();
      })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
    if (!this.productTemplate.id) {
      VbSnackbarService.showError('Produto não encontrado');
    }
  }

  @Emit('success')
  private success(): void {}

  @Emit('cancel')
  private cancel(): void {}
}
